import { render, staticRenderFns } from "./OzConfirmationDialogBox.vue?vue&type=template&id=10c42ea0&"
import script from "./OzConfirmationDialogBox.vue?vue&type=script&lang=ts&"
export * from "./OzConfirmationDialogBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports